export default "__VITE_ASSET__ZaUL6gaI__"